// @ts-check
/**
 * @file useUnreadBadge.js
 * @location src/hooks/useUnreadBadge.js
 * @role 내 안 읽음 업무 카운트 파생 → 탭 타이틀·favicon 배지·30분 재진입 토스트.
 *   안 읽음 = aee===uid && status==='todo' && !acknowledgedAt.
 */
import { useEffect } from 'react';
import { useDocumentTitle } from './useDocumentTitle.js';
import { useReentryToast } from './useReentryToast.js';
import { updateFaviconBadge } from '../utils/favicon.js';

/**
 * @param {object} p
 * @param {import('../data/types.js').Task[]} p.tasks
 * @param {string} p.uid - 로그인 중인 멤버 id
 * @param {(msg: string, kind?: string) => void} p.showToast
 * @returns {number} myUnreadCount
 */
export function useUnreadBadge({ tasks, uid, showToast }) {
  const myUnreadCount = (tasks ?? []).filter(t =>
    t.aee === uid && t.status === 'todo' && !t.acknowledgedAt
  ).length;

  useDocumentTitle(myUnreadCount);
  useEffect(() => { updateFaviconBadge(myUnreadCount); }, [myUnreadCount]);

  useReentryToast(() => {
    if (myUnreadCount > 0) showToast(`새 업무 ${myUnreadCount}건`, 'ok');
  });

  return myUnreadCount;
}
